import { Link} from '@material-ui/icons'
import {IconButton} from '@material-ui/core'
import React from 'react'
import './project.css'
function Project({title,image,url,body}) {
return (
    
<section id="portfolio">

<div className="project">

<div className="project__body"  >
<img  src={image}/>
<div className="project__all">
<div className="body__title">
<h5>{title}</h5>
<IconButton href={url}>
< Link className="ic" fontSize="large" href={url}/>
</IconButton>
</div>
<div className="url">
<p>{body}</p>
</div>
</div>
</div>

</div>
</section>
)
}

export default Project
